import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Dreamhosting",
  "description": "",
  "published": "2007-12-29T00:00:00.000Z",
  "redirect_from": ["/blog/dreamhosting/swizec/139"],
  "categories": "life, linkages",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago I got kind of fed up of relying on a free hosting service provided me by my friends at `}<a parentName="p" {...{
        "href": "http://unimatrix-one.org/"
      }}>{`unimatrix-one`}</a>{` and shelved out the moneys needed for `}<a parentName="p" {...{
        "href": "http://www.dreamhost.com/"
      }}>{`dreamhost`}</a>{`. It's surprisingly little for what you actually get if you ask me.`}</p>
    <p>{`Upon registering I was offered a `}<a parentName="p" {...{
        "href": "http://3pike.org/"
      }}>{`free domain`}</a>{` to go with the hosting and having no better ideas at the time I did what any geek with a girlfriend would do. I made a `}<a parentName="p" {...{
        "href": "http://3pike.org/"
      }}>{`domain`}</a>{` out of my wench's nickname. Sure, at first I did intend it to be her blog because she is using something completely unfit for a geek's girlfriend, but as she said she doesn't need one I put up a `}<a parentName="p" {...{
        "href": "http://3pike.org/"
      }}>{`picture`}</a>{` of her. She loved the gesture, hates the picture ... and that's exactly why I chose that particular one.`}</p>
    <p>{`As for `}<a parentName="p" {...{
        "href": "http://www.dreamhost.com/"
      }}>{`dreamhost`}</a>{`, they seem quite nice so far. Responsiveness is superbly quick and I have more space than I could ever imagine I'd need, with said space increasing weekly, amazing. The monthly, I think it's monthly, transfer is also something I will probably never exceed ... and also increases weekly. Should the need ever arise I can even get a dedicated host ... lovely.`}</p>
    <p>{`So yeah, so far I'm pleased with dreamhost and it gave me a fun day, because what better can a geek want than a completely new hosting account to play with and set stuff up?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      